'use client'

import { IBlock } from './block'
// import { useStore } from '@/store'
import BlockWrapper, { BlockStyle } from './block.style'

// const propsInterface = [
//   { name: 'Block style', input: { type: 'style' , model: { styleModel: { width: 'number', height: 'number', border: 'number', color: 'list-color', padding: 'number' } } } }
// ]

const BlockPanel = ({ edit = true, children }: any) => {
  // const cStore = useStore(store)

  const showProperties = () => {
    // cStore.setCurrentBlockID({
    //   blockID: uuid,
    //   interface: propsInterface,
    //   state: {
    //     width: 0,
    //     height: 0,
    //     border: 0,
    //     color: []
    //   }
    // })
  }

  return (
    <BlockWrapper onClick={() => edit && showProperties()} edit={edit}>
      {children}
    </BlockWrapper>
  )
}

const Block = ({ children, width }: IBlock) => {
  return <BlockStyle width={width}>{children}</BlockStyle>
}

export default BlockPanel
